import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { PaymentGuard } from './guards/payment.guard';
import { PaymentCompleteGuard } from './guards/payment-complete.guard';
import { LandingGuard } from './guards/landing.guard';

const routes: Routes = [
    // Landing page - carga inmediata
    {
        path: '', 
        loadChildren: () => import('./modules/landing/landing.module').then(m => m.LandingModule),
        canActivate: [LandingGuard]
    },
    
    // Módulo de autenticación - lazy loading
    {
        path: 'auth',
        loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
    },
    
    // Módulo del curso - lazy loading con guards
    {
        path: 'course',
        loadChildren: () => import('./modules/course/course.module').then(m => m.CourseModule),
        canActivate: [AuthGuard]
    },
    
    // Módulo de pagos - lazy loading
    {
        path: 'payment',
        loadChildren: () => import('./modules/payment/payment.module').then(m => m.PaymentModule)
    },
    
    // Rutas legacy para mantener compatibilidad
    {path: 'login', redirectTo: 'auth/login'},
    {path: 'register', redirectTo: 'auth/register'},
    {path: 'forgot-password', redirectTo: 'auth/forgot-password'},
    {path: 'reset-password', redirectTo: 'auth/reset-password'},
    
    // Rutas del curso
    {path: 'principal-menu', redirectTo: 'course/principal-menu'},
    {path: 'phase-one', redirectTo: 'course/phase-one'},
    {path: 'phase-two', redirectTo: 'course/phase-two'},
    {path: 'phase-three', redirectTo: 'course/phase-three'},
    {path: 'phase-four', redirectTo: 'course/phase-four'},
    {path: 'phase-five', redirectTo: 'course/phase-five'},
    {path: 'phase-six', redirectTo: 'course/phase-six'},
    {path: 'phase-seven', redirectTo: 'course/phase-seven'},
    {path: 'video-player', redirectTo: 'course/video-player'},
    {path: 'support', redirectTo: 'course/support'},
    
    // Rutas de pagos
    {path: 'checkout', redirectTo: 'payment/checkout'},
    {path: 'checkout-oxxo', redirectTo: 'payment/checkout-oxxo'},
    {path: 'checkout-transfer', redirectTo: 'payment/checkout-transfer'},
    {path: 'payment-options', redirectTo: 'payment/payment-options'},
    {path: 'payment-complete', redirectTo: 'payment/payment-complete'},
    
    // Rutas de landing
    {path: 'about-tudi', redirectTo: 'about-tudi'},
    {path: 'terms-and-conditions', redirectTo: 'terms-and-conditions'},
    // Ruta por defecto
    {path: '**', redirectTo: ''}

];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        scrollPositionRestoration: 'top'
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {}